module.exports = __webpack_public_path__ + "img/layout_triangle_icon.19cb4e9a.svg";